import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment.prod';
import { User } from '../models/user.model';

@Injectable({ providedIn: 'root' })
export class AccountService {
    private userSubject: BehaviorSubject<User>;
    public user: Observable<User>;

    constructor(
        private router: Router,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string
    ) {
        this.userSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('user')));
        this.user = this.userSubject.asObservable();
    }

    public get userValue(): User {
        return this.userSubject.value;
    }

    login(username, password) {
        const httpHeaders = new HttpHeaders();
        return this.http.post<User>(`${this.baseUrl}user/authenticate`, { login: username,senha: password },{ headers: httpHeaders })
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
                this.userSubject.next(user);
                return user;
            }));
    }

    logout() {
        // remove user from local storage and set current user to null
        localStorage.removeItem('user');
        this.userSubject.next(null);
        this.router.navigate(['/account/login']);
    }

    register(user: User) {
        const httpHeaders = new HttpHeaders();
        return this.http.post(`${this.baseUrl}user/register`, user);
    }

    getAll() {
        const httpHeaders = new HttpHeaders();
        return this.http.get<User[]>(`${this.baseUrl}/user/getall`);
    }

    getById(id: string) {
        const httpHeaders = new HttpHeaders();
        return this.http.get<User>(`${this.baseUrl}users/${id}`);
    }

    update(id, params) {
        const httpHeaders = new HttpHeaders();
        return this.http.post(`${this.baseUrl}users/${id}`, params,{ headers: httpHeaders })
            .pipe(map(x => {
                // update stored user if the logged in user updated their own record
                if (id == this.userValue.idUsuario) {
                    // update local storage
                    const user = { ...this.userValue, ...params };
                    localStorage.setItem('user', JSON.stringify(user));

                    // publish updated user to subscribers
                    this.userSubject.next(user);
                }
                return x;
            }));
    }

    delete(id: string) {
        const httpHeaders = new HttpHeaders();
        return this.http.delete(`${this.baseUrl}users/${id}`,{ headers: httpHeaders })
            .pipe(map(x => {
                // auto logout if the logged in user deleted their own record
                if (id == this.userValue.idUsuario) {
                    this.logout();
                }
                return x;
            }));
    }
}